import { AlarmLite } from './alarm-lite';
import { StandardEntity } from '@infodata-group/inf-commons';
import { Gps } from '../../modules/shared/model/gps';

export class Alarm extends AlarmLite {
  public title: string;
  public client: StandardEntity;
  public site: StandardEntity;
  public material: StandardEntity;
  public tour: StandardEntity;
  public tag: StandardEntity;
  public status: StandardEntity;
  public comment: string;
  public remark: string;
  public location: Gps;
  public tourGroup: StandardEntity;
}
